import React, {Component} from 'react'
import axios from 'axios';
import Template from './interfaz/Template'
import {connect} from 'react-redux';
import { userLogout } from '../redux/user/user-actions';
import { selectCurrentUser } from '../redux/user/user-selectors';
import { createStructuredSelector } from 'reselect';
import * as etiquetas from '../ApplicationResources';

class Logout extends Component {

	componentDidMount() {
		const jwt = localStorage.getItem('jwt-token');

		if (jwt) {
			axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/cierraSesion', {
				idSistema:etiquetas.idSistema
			},
			{
				headers: { Authorization: jwt}
			});
		}

		localStorage.removeItem('jwt-token');
		this.props.terminarSesion();

		if(this.props.location.state && this.props.location.state.tipoCierre) {
			// Se validará el tipo de cierre de sesión
			this.props.history.push({
				pathname: '/loginSEyCAE',
				state: { tipoCierre: this.props.location.state.tipoCierre }
			});
		} else
			this.props.history.push('/loginSEyCAE');
	}

	render() {
		return <Template guia={false} bloqueado={true}/>;
	}
}

const mapStateToProps = createStructuredSelector({
	currentUser : selectCurrentUser
});

const mapDispatchToProps = dispatch => ({
	terminarSesion: () => dispatch(userLogout())
});

export default connect(mapStateToProps , mapDispatchToProps)(Logout);